import { createContext } from '@chakra-ui/react-utils';

import type { UseStickToBottomReturn } from './useStickToBottom';

export type ConversationContext = UseStickToBottomReturn;

export const [ConversationProvider, useConversationContext] =
  createContext<ConversationContext>({
    name: 'ConversationContext',
    strict: true,
    errorMessage:
      'useConversationContext: `context` is undefined. Seems you forgot to wrap components within `<Conversation />`',
  });
